import { Select } from "@/components/atoms";
import type { SegmentSelectorProps } from "./types";

const NO_SEGMENT_ID = "";

export function SegmentSelector({ selectedId, segments, onChange, emptyMessage, isLoading }: SegmentSelectorProps) {
  const uniqueSegments = Array.from(
    new Map(
      segments.map((segment) => [(segment.displayName ?? "").toLowerCase(), segment] as const)
    ).values()
  );

  return (
    <Select
      label="Segment"
      options={[
        { id: NO_SEGMENT_ID, label: "No segment" },
        ...uniqueSegments.map((segment) => ({ id: segment.id, label: segment.displayName })),
      ]}
      value={selectedId ?? NO_SEGMENT_ID}
      onChange={(value) => onChange(value === NO_SEGMENT_ID ? null : value as number)}
      placeholder="Select segment"
      emptyMessage={emptyMessage || "No segments available"}
      isLoading={isLoading}
      searchable
    />
  );
}
